import { useEffect, useRef, useState } from "react";
// Custom Components
import BurgerOnDisplay from "../burgerOnDisplay";
import TimerBar from "../timerBar";

// Images
import { burgerType } from "../../constants/ingredients";
import { PAUSE_TIMER_EVENT, RESUME_TIMER_EVENT } from "../../constants/const";
import emojiSmile from "../../assets/images/emoji/emoji_smile.svg";
import emojiSad from "../../assets/images/emoji/emoji_sad.svg";
import emojiAngry from "../../assets/images/emoji/emoji_angry.svg";
// Styles
import "./styles.scss";

const DisplayItem = (props) => {
  const [time, setTime] = useState(0);
  const timeInterval = useRef()

  const triggerEmojiTimer = () => {
    timeInterval.current = setInterval(() => {
      setTime(time => time + 1);
    }, 1000);
  }

  const getEmoji = () => {
    const actualTime = Math.ceil(burgerType[props.burger].time / 10);

    if (0 <= time && time < 6 * actualTime) return emojiSmile;
    if (time >= 6 * actualTime && time < 8 * actualTime) return emojiSad;
    if (time >= 8 * actualTime && time < 9 * actualTime) return emojiAngry;
    else return emojiAngry;
  };

  const handlePauseTimer = () => {
    clearInterval(timeInterval.current)
  }

  useEffect(() => {
    if (time >= burgerType[props.burger].time) return;
  }, [time]);

  useEffect(() => {
    triggerEmojiTimer()
    window.addEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
    window.addEventListener(RESUME_TIMER_EVENT, triggerEmojiTimer)
    return () => {
      clearInterval(timeInterval.current);
      window.removeEventListener(PAUSE_TIMER_EVENT, handlePauseTimer)
      window.removeEventListener(RESUME_TIMER_EVENT, triggerEmojiTimer)
    }
  }, [])

  return (
    <div className={`display-item-style ${props.className}`}>
      <div className={`emoji-container`}>
        <img src={getEmoji()} alt="" />
        {/* {time} */}
      </div>
      <div className="burger-section">
        <BurgerOnDisplay
          burger={props.burger}
          index={props.index}
          expectedEndTime={props.expectedEndTime}
        />
      </div>
      <div className="timer-container">
        <TimerBar
          time={burgerType[props.burger].time}
          pushedTime={props.pushedTime}
        />
      </div>
    </div>
  );
};

export default DisplayItem;
